import WithdrawalAccount from './WithdrawalAccount';
import AccountManager from './AccountManager';
import ContactSupport from './ContactSupport';
import InviteFriends from './InviteFriends';
import ManagePayroll from './ManagePayroll';
import BusinessInfo from './BusinessInfo';
import Security from './Security';
import Settings from './Settings';
import Logout from './Logout';
import InventoryConfig from './InventoryConfig';
import ManageProductSalesConfig from './ManageProductSalesConfig';
import Kyc from './Kyc';
import AddBusiness from './AddBusiness';
import Faqs from './Faqs';
import GeneralSettings from './GeneralSettings';
import CardInfo from './CardInfo';
import InvoiceReminder from './InvoiceReminder';
import Subscriptions from './Subscriptions';
import RenewSub from './RenewSub';
import ApiKeys from './ApiKeys';
import FreePlanConfirmation from './FreePlanConfirmation';

export {
	AccountManager,
	BusinessInfo,
	AddBusiness,
	Security,
	Settings,
	InviteFriends,
	Logout,
	ManageProductSalesConfig,
	ContactSupport,
	WithdrawalAccount,
	ManagePayroll,
	InventoryConfig,
	Kyc,
	Faqs,
	GeneralSettings,
	CardInfo,
	InvoiceReminder,
	Subscriptions,
	RenewSub,
	ApiKeys,
	FreePlanConfirmation,
};
